import React, { useState } from 'react';
import Navigation from './Navigation';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md p-4 flex items-center justify-between fixed top-0 left-0 w-full z-50">
      {/* Logo */}
      <h1 className="text-3xl font-extrabold text-gradient font-serif cursor-pointer tracking-wider" style={{ fontFamily: 'Hatton, serif' }}>
        <a href="#welcome">cerise</a>
      </h1>

      {/* Hamburger Menu Button (Only for Mobile) */}
      <button
        className="md:hidden flex items-center justify-center w-10 h-10 text-gray-800"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
      >
        <svg
          className="w-6 h-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
          />
        </svg>
      </button>

      {/* Navigation */}
      <Navigation isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
    </header>
  );
};

export default Header;
